'use client';

import { Locale } from '@core/Entities/Locale/Locale.entity';

import { Vehicle } from '@core/Entities/Vehicle/Vehicle.entity';
import styles from './HeyCarStaticFinance.module.css';
import { Typography } from '@gds/Typography/Typography';
import Button from '@gds/Button/Button';
import { useNavigateToCheckout } from '../../Hooks/useNavigateToCheckout';
import { isHeycarConnectStaticFinanceDealer } from '@core/Utils/Vehicle/IsHeycarConnect';
import { getFormattedFinanceValuesFromVehicle } from '../../Utils/getFormatedFinanceValuesFromVehicle';
import { FinanceDetails } from '../FinanceDetails/FinanceDetails';

type Strings = {
  title: string;
  description: string;
  totalDeposit: string;
  month: string;
  totalMileage: string;
  totalDuration: string;
  fixedApr: string;
  orderOnline?: string;
};

export const HeyCarStaticFinance = ({
  strings,
  locale,
  vehicle,
  showDetailsOnly,
}: {
  locale: Locale;
  strings: Strings;
  vehicle: Vehicle;
  showDetailsOnly?: boolean;
}) => {
  const hasStaticFinancing = isHeycarConnectStaticFinanceDealer(vehicle);
  const { handleNavigateToCheckoutClick } = useNavigateToCheckout({ locale });

  if (!hasStaticFinancing || !vehicle?.finance) {
    return null;
  }

  const { deposit, monthlyPrice, months, mileage } = getFormattedFinanceValuesFromVehicle(
    vehicle?.finance,
    vehicle?.pricing,
    locale,
  );

  if (showDetailsOnly) {
    return (
      <FinanceDetails
        strings={strings}
        values={{
          deposit,
          monthlyPrice,
          months,
          mileage,
        }}
      />
    );
  }

  return (
    <div className={styles.wrapper} id="financing-calculator">
      <Typography variant={'h5'} className={styles.title}>
        {strings.title}
      </Typography>
      <Typography variant={'body4'}>{strings.description}</Typography>
      <FinanceDetails
        strings={strings}
        values={{
          deposit,
          monthlyPrice,
          months,
          mileage,
        }}
      >
        <Button className={styles.button} onClick={handleNavigateToCheckoutClick}>
          {strings.orderOnline}
        </Button>
      </FinanceDetails>
    </div>
  );
};
